import { Component, inject } from '@angular/core';

import { FloatLabel } from 'primeng/floatlabel';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { InputText } from 'primeng/inputtext';
import { TranslatePipe, TranslateService, TranslateModule } from '@ngx-translate/core';
import { UnauthenticatedLayoutComponent } from '@angular-monorepo/ui';
import { AuthService } from '../../data-access/auth.service';
import { Router, RouterLink } from '@angular/router';
import { Button } from 'primeng/button';
import { PasswordModule } from 'primeng/password';

@Component({
  selector: 'lib-register',
  imports: [
    FloatLabel,
    FormsModule,
    InputText,
    TranslatePipe,
    ReactiveFormsModule,
    UnauthenticatedLayoutComponent,
    RouterLink,
    Button,
    PasswordModule,
    TranslateModule,
  ],
  templateUrl: './register.component.html',
  styleUrl: './register.component.css',
})
export class RegisterComponent {
  private formBuilder = inject(FormBuilder);
  private translate = inject(TranslateService);
  private authService = inject(AuthService);
  private router = inject(Router);

  showPassword = false;
  form: FormGroup;

  constructor() {
    this.form = this.formBuilder.group({
      email: [
        '',
        [Validators.required, Validators.email, Validators.minLength(3), Validators.maxLength(250)],
      ],
      password: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(100)]],
      name: ['', [Validators.minLength(3), Validators.maxLength(100)]],
    });
  }

  onSubmitRegister() {
    if (this.form.valid) {
      const registerData = {
        email: this.form.value.email,
        password: this.form.value.password,
        name: this.form.value.name,
      };

      this.authService.register(registerData).subscribe({
        next: (response) => {
          if (response.success) {
            console.log('Registro exitoso:', response.message);
            this.router.navigate(['/login']).then((r) => r);
          }
        },
      });
    } else {
      this.form.markAllAsTouched();
    }
  }

  getEmailError(): string {
    const control = this.form.get('email');
    if (control?.hasError('required')) return this.translate.instant('auth.errors.required');
    if (control?.hasError('email')) return this.translate.instant('auth.errors.email');
    if (control?.hasError('minlength')) return this.translate.instant('auth.errors.minlength');
    return '';
  }

  getPasswordError(): string {
    const control = this.form.get('password');
    if (control?.hasError('required')) return this.translate.instant('auth.errors.required');
    if (control?.hasError('minlength')) return this.translate.instant('auth.errors.minlength');
    return '';
  }

  getNameError(): string {
    const control = this.form.get('name');
    if (control?.hasError('required')) return this.translate.instant('auth.errors.auth.required');
    if (control?.hasError('minlength')) return this.translate.instant('auth.errors.auth.minlength');
    return '';
  }
}
